import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { MapPinIcon } from 'lucide-react';
export function DiasporaSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full py-28 px-6 relative overflow-hidden" style={{
    background: 'linear-gradient(135deg, #0d0505 0%, #0a0a0a 40%, #050a0d 100%)'
  }} data-id="element-50">
      {/* Background accent */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `radial-gradient(ellipse at 50% 50%, #CF9B2E 0%, transparent 70%)`
    }} data-id="element-51" />

      <div className="relative z-10 max-w-4xl mx-auto" data-id="element-52">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-12" data-id="element-53">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-54">
            <MapPinIcon className="w-6 h-6 text-[#CF9B2E]" data-id="element-55" />
            <p className="text-[#CF9B2E] uppercase tracking-[0.3em] text-sm font-bold font-['Lato']" data-id="element-56">
              Para los que tuvieron que irse
            </p>
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-[#F5F0E8] mb-8 leading-tight" data-id="element-57">
            Estás en otro país,
            <br data-id="element-58" />
            <span className="text-[#CF9B2E]" data-id="element-59">pero Venezuela sigue en ti.</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-6 text-center" data-id="element-60">
          <p className="text-xl md:text-2xl text-[#E8D5B0] leading-relaxed" style={{
          fontFamily: 'Playfair Display, serif',
          fontStyle: 'italic'
        }} data-id="element-61">
            Saliste porque no quedaba otra opción. Dejaste atrás a tu madre, a
            tus amigos, a las calles que te vieron crecer. Y aunque hoy vives en
            otro continente, hay noches en que el peso de lo que pasó te
            aplasta.
          </p>

          <p className="text-lg md:text-xl text-[#9A9080] leading-relaxed" style={{
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-62">
            No estás solo. Más de{' '}
            <span className="text-[#CF9B2E] font-semibold" data-id="element-63">
              7 millones de venezolanos
            </span>{' '}
            cargamos esa misma mochila invisible. Este libro es para todos
            nosotros. Es el testimonio de lo que vivimos, de lo que perdimos, y
            de por qué nunca debemos olvidar.
          </p>

          <p className="text-lg md:text-xl text-[#E8D5B0] leading-relaxed" style={{
          fontFamily: 'Playfair Display, serif',
          fontStyle: 'italic'
        }} data-id="element-64">
            Regálaselo a quien no entiende por qué te fuiste. Léelo tú mismo
            cuando necesites recordar que tu historia importa. Compártelo con
            tus hijos para que sepan de dónde vienen.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        delay: 0.6
      }} className="mt-14 flex justify-center" data-id="element-65">
          <div className="flex gap-4 flex-wrap justify-center text-sm text-[#9A9080] font-['Lato']" data-id="element-66">
            <span className="flex items-center gap-2" data-id="element-67">
              <span className="w-2 h-2 rounded-full bg-[#C0392B] inline-block" data-id="element-68" />
              Colombia
            </span>
            <span className="flex items-center gap-2" data-id="element-69">
              <span className="w-2 h-2 rounded-full bg-[#CF9B2E] inline-block" data-id="element-70" />
              España
            </span>
            <span className="flex items-center gap-2" data-id="element-71">
              <span className="w-2 h-2 rounded-full bg-[#1A5276] inline-block" data-id="element-72" />
              Estados Unidos
            </span>
            <span className="flex items-center gap-2" data-id="element-73">
              <span className="w-2 h-2 rounded-full bg-[#C0392B] inline-block" data-id="element-74" />
              Chile
            </span>
            <span className="flex items-center gap-2" data-id="element-75">
              <span className="w-2 h-2 rounded-full bg-[#CF9B2E] inline-block" data-id="element-76" />
              Perú
            </span>
            <span className="flex items-center gap-2" data-id="element-77">
              <span className="w-2 h-2 rounded-full bg-[#1A5276] inline-block" data-id="element-78" />
              Argentina
            </span>
            <span className="flex items-center gap-2" data-id="element-79">
              <span className="w-2 h-2 rounded-full bg-[#C0392B] inline-block" data-id="element-80" />
              y 12 países más
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}